import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ResultsPage from './components/ResultsPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/:submissionId" element={<ResultsPage />} />
          <Route path="/" element={<WelcomePage />} />
        </Routes>
      </div>
    </Router>
  );
}

function WelcomePage() {
  return (
    <div className="home">
      <div className="home-inner">
        <img src="/Logo_AmCham_horizontal.png" alt="AmCham Argentina" className="amcham-logo" />
        <p className="home-kicker">AmCham Argentina</p>
        <h1>AI Readiness Assessment</h1>
        <p className="home-lead">
          Para ver los resultados de un formulario, agregá el Submission ID a la URL.
        </p>
        <p className="home-example">
          Ejemplo: <span>/afd5824f-05ab-4511-9195-1effc87d05e1</span>
        </p>
      </div>
    </div>
  );
}

export default App;
